export const environment = {
   apiUrl: 'http://cdi-researchassistant.preview.summon.serialssolutions.com/cda',
   deeplinkUrl: 'http://bo0001.qos.pc.dc04.hosted.exlibrisgroup.com:8080/test/solr-id'
}
